export const LOG_LEVEL = {
  ERROR: 1,
  WARN: 2,
  INFO: 3,
  DEBUG: 4,
  NONE: 5,
};

class Log {
  private static logLevel: number = LOG_LEVEL.DEBUG;

  static setLogLevel(level: number) {
    this.logLevel = level;
  }

  static getLogLevel(): number {
    return this.logLevel;
  }

  static log(...data: any[]) {
    if (Log.getLogLevel() >= LOG_LEVEL.DEBUG) {
      console.log(...data);
    }
  }

  static debug(...data: any[]) {
    if (Log.getLogLevel() >= LOG_LEVEL.DEBUG) {
      console.log(...data);
    }
  }

  static info(...data: any[]) {
    if (Log.getLogLevel() >= LOG_LEVEL.INFO) {
      console.info(...data);
    }
  }

  static warn(...data: any[]) {
    if (Log.getLogLevel() >= LOG_LEVEL.WARN) {
      console.warn(...data);
    }
  }

  static error(...data: any[]) {
    if (Log.getLogLevel() >= LOG_LEVEL.ERROR) {
      console.error(...data);
    }
  }
}

export default Log;
